import onsiteNotification from './onsite-notification';

export default { fromJSON };

// Translate from HAL API to local data structure
function fromJSON(json) {
    if (!json) {
        return null;
    }

    return json._embedded.notifications.map(onsiteNotification.fromJSON);
}



// WEBPACK FOOTER //
// ./~/@99designs/globalnav/src/models/onsite-notification-collection.js